import { themeAtom } from "../../shared/atoms";
import { useAtomValue } from "jotai";
import React from "react";
import { twMerge } from "tailwind-merge";

type ReusableButtonProps = {
  buttonType?: "button" | "submit" | "reset";
  width?: number; // pixels
  buttonText: string;
  onClickHandler: () => void;
  className?: string;
  disabled?: boolean;
};

export function ReusableButton({
  buttonType = "button",
  width,
  buttonText,
  onClickHandler,
  className,
  disabled,
}: ReusableButtonProps): React.JSX.Element {
  const theme = useAtomValue(themeAtom);

  return (
    <button
      type={buttonType}
      onClick={onClickHandler}
      disabled={disabled}
      className={twMerge(
        "flex h-[36px] flex-shrink-0 items-center justify-center rounded border border-green text-[14px] text-green hover:bg-green focus:outline-none",
        theme.headerComponent.notifications.itemBackground,
        theme.headerComponent.tailwind.buttonHoverText,
        disabled && "cursor-not-allowed opacity-60 hover:bg-transparent hover:text-green",
        className,
      )}
      style={{ width }}
    >
      {buttonText}
    </button>
  );
}
